import axios from 'axios'

const state = {
  steps: [
    {
      step: 1,
      title: 'customer.phrase_connector.step_one.title',
      complete: false,
      routeName: 'clientPhraseConnectorStepOne'
    },
    {
      step: 2,
      title: 'customer.phrase_connector.step_two.title',
      complete: false,
      routeName: 'clientPhraseConnectorStepTwo'
    },
    {
      step: 3,
      title: 'customer.phrase_connector.step_three.title',
      routeName: 'clientPhraseConnectorStepThree',
      complete: false,
      webhook: false,
      provider: false
    }
  ]
}

const mutations = {
  setAccess(state, payload) {
    state.steps[0].complete = payload
  },
  setWorkflow(state, payload) {
    state.steps[1].complete = payload
  },
  setWebhook(state, payload) {
    state.steps[2].webhook = payload
  },
  setProvider(state, payload) {
    state.steps[2].provider = payload
  }
}

const actions = {
  async registerPhrase({ rootState }, payload) {
    try {
      const client_id = localStorage.getItem('phrase_connector_client_id')
      const data = {
        data: {
          type: 'access',
          attributes: {
            team: rootState['account'].account.attributes.team_identifier,
            client_id: client_id,
            code: payload.code,
            state: payload.state
          }
        }
      }

      // phrase register
      const response = await axios.post(
        `/connectors/api/v1/authentication/phrase/register?code=${payload.code}&state=${payload.state}`,
        data
      )

      return response
    } catch (err) {
      throw new Error(JSON.stringify(err))
    }
  },

  async createWebhook({ rootState }) {
    try {
      const data = {
        data: {
          type: 'webhook',
          attributes: {
            team: rootState['account'].account.attributes.team_identifier
          }
        }
      }

      // create webhook
      const response = await axios.post(
        '/connectors/api/v1/authentication/phrase/create_webhook',
        data
      )
    } catch (err) {
      throw new Error(JSON.stringify(err))
    }
  },

  async createProvider({ rootState }) {
    try {
      const data = {
        data: {
          type: 'provider',
          attributes: {
            team: rootState['account'].account.attributes.team_identifier
          }
        }
      }

      // create provider
      const response = await axios.post(
        '/connectors/api/v1/authentication/phrase/create_provider',
        data
      )
    } catch (err) {
      throw new Error(JSON.stringify(err))
    }
  },
  async status({ commit, rootState }) {
    try {
      const data = {
        data: {
          type: 'status',
          attributes: {
            team: rootState['account'].account.attributes.team_identifier
          }
        }
      }

      const response = await axios.post(
        '/connectors/api/v1/authentication/phrase/status',
        data
      )

      commit('setAccess', response.data.data.attributes.access_token)
      commit('setWorkflow', response.data.data.attributes.workflow)
      commit('setWebhook', response.data.data.attributes.webhook)
      commit('setProvider', response.data.data.attributes.provider)
    } catch (err) {
      throw new Error(JSON.stringify(err))
    }
  }
}

const getters = {
  connectionSuccessful(state) {
    return (
      state.steps[0].complete &&
      state.steps[1].complete &&
      state.steps[2].webhook &&
      state.steps[2].provider
    )
  },
  workflowCreated(state) {
    return state.steps[1].complete
  },
  webhookCreated(state) {
    return state.steps[2].webhook
  },
  providerCreated(state) {
    return state.steps[2].provider
  }
}

export const phraseConnector = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
